export default "__VITE_ASSET__0a18641a__"